import CoachDetails from './CoachDetails';

export default CoachDetails;
